<template>
  <div class="manage-players">
    <h2 class="title is-3">Manage players</h2>
    <p class="subtitle is-5">Remove players and edit scores</p>
    <b-input v-model="playerSearch" type="text" placeholder="Search for a player" />
    <EventPlayers
      :eventId="eventId"
      :players="players"
      :canEditScore="true"
      :canRemovePlayer="true"
      :isBusinessAvatar="showBusinessAvatars"
      :playerSearch="playerSearch"
      @playerRemoved="playerRemoved"
      @scoreUpdated="scoreUpdated"
    />
  </div>
</template>

<script>
import AvatarControls from '~/components/mixins/AvatarControls'
import EventPlayers from '~/components/EventPlayers.vue'
import { avatarStyles } from '~/common/avatars'

export default {
  components: {
    EventPlayers
  },
  mixins: [ AvatarControls ],
  props: [ 'players', 'eventId' ],
  data () {
    return {
      playerSearch: ''
    }
  },
  computed: {
    showBusinessAvatars () {
      return this.avatarStyle === avatarStyles.BUSINESS
    }
  },
  methods: {
    playerRemoved (playerId) {
      this.$emit('playerRemoved', playerId)
      this.$emit('close')
    },
    scoreUpdated () {
      this.$emit('scoreUpdated')
    }
  }
}
</script>
<style lang="scss" scoped>
.manage-players {
  background-color: white;
  padding: 30px;
  border-radius: 12px;
  max-width: 550px;
  margin: 0 auto;
}
</style>
